import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';

const leverageForm = {
  fields: {
    loanToCost: {
      value: 0,
      error: null,
      rule: '',
    },
    constructionReserve: {
      value: 0,
      error: null,
      rule: '',
    },
    initialAdvance: {
      value: 0,
      error: null,
      rule: '',
    },
    constructionHoldback: {
      value: 0,
      error: null,
      rule: '',
    },
    pricingType: {
      value: 'ltc',
      error: null,
      rule: 'required',
    }
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class StabilizedBridgeLeverageFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(leverageForm, globalStore);
  }
}
